import React from 'react';
import PropTypes from 'prop-types';
import { Components, Utils, translate } from 'versafleet-core';
import { connect } from 'react-redux';
import ReduxActions from 'reduxActions';
import TaskModule from 'modules/task';
import { isUserReadOnly } from 'utils/accessHelper';
import Detail from '../detail';

const {
  Helper, FullScreenLoading, Dialog,
} = Utils;

class MobileTaskViewForm extends React.Component {
  UNSAFE_componentWillMount() {
    FullScreenLoading.FullScreenLoadingManager.open(this.props.strings.Task.page.loadingItem);
    this.props.dispatch(ReduxActions.task.fetch(Utils.Router.getParams().id))
      .then((res) => {
        if ((res.task.custom_field_group || {}).id) {
          this.props.dispatch(ReduxActions.customFieldGroup.fetch(res.task.custom_field_group.id));
        }
      })
      .then(() => {
        FullScreenLoading.FullScreenLoadingManager.close();
      });
  }

  _isEditable() {
    const task = this.props.data || {};
    const job = task.job || {};
    let isEditable = !isUserReadOnly();

    if (this.props.myjobsSetting) {
      // Check task state first
      if (['successful', 'completed'].indexOf(task.state) > -1) {
        isEditable = isEditable && (this.props.myjobsSetting.can_edit_after_completion);
      } else if (['submitted', 'in_progress'].indexOf(job.state) > -1) {
        isEditable = isEditable && this.props.myjobsSetting.can_edit_after_submission;
      }
    }

    return isEditable;
  }

  _renderNavBar() {
    const data = this.props.data || {};
    const job = data.job || {};
    const menuItems = [];

    if (this._isEditable()
      && ['draft', 'submitted', 'rejected', 'cancelled'].indexOf(job.state) > -1) {
      if (this.props.data.archived) {
        menuItems.push({
          text: this.props.strings.Task.form.buttons.unarchive,
          action: () => {
            FullScreenLoading.FullScreenLoadingManager.open(
              this.props.strings.Task.page.unarchivingItem,
            );
            this.props.dispatch(ReduxActions.task.unarchive(this.props.data.id))
              .then(() => {
                Utils.Router.transitionTo('/tasks');
              })
              .then(() => {
                FullScreenLoading.FullScreenLoadingManager.close();
              });
          },
          iconClassName: this.props.data.archived ? 'versa-unarchive' : 'versa-archive',
        });
      }
    }

    if (!this.props.data.archived && this.props.data.state === 'successful' && !Helper.isNullOrUndefined(this.props.data.epod_url)) {
      menuItems.push({
        text: this.props.strings.Task.form.buttons.viewEPOD,
        action: () => window.open(this.props.data.epod_url, '_blank'),
        iconClassName: 'versa-epod',
        iconText: '',
      });
    }

    if (this._isEditable() && !data.archived
      && ['successful', 'cancelled', 'completed'].indexOf(data.state) === -1
      && ['draft', 'submitted', 'rejected', 'cancelled'].indexOf(job.state) > -1) {
      menuItems.push({
        text: this.props.strings.Task.form.buttons.cancel,
        action: () => {
          Dialog.DialogManager.open(
            <TaskModule.CancelDialog
              dataIds={[this.props.data.id]}
              shouldPopRoute
            />,
          );
        },
        iconClassName: 'versa-danger',
      });
    }

    if (this.props.data.archived && this._isEditable()) {
      menuItems.push({
        text: this.props.strings.Task.form.buttons.delete,
        action: () => {
          Dialog.DialogManager.open((
            <TaskModule.DeleteDialog
              dataIds={[this.props.data.id]}
              shouldPopRoute
            />
          ));
        },
        iconClassName: 'versa-delete',
      });
    }

    return (
      <Components.Mobile.NavigationBar
        leftButton={Components.Mobile.NavigationBar.buttonConst.CLOSE}
        onLeftButtonClick={() => Utils.Router.transitionTo('/tasks')}
        renderRightPanel={() => [(
          ['draft', 'rejected', 'submitted'].indexOf(this.props.data.job.state) > -1
            && !this.props.data.archived
            && !isUserReadOnly()
            && this._isEditable() ? (
              <Components.Button
                iconClassName="versa-edit"
                id="vf-mobile-task__view-form__edit-button"
                onClick={() => Utils.Router.transitionTo(`/tasks/${Utils.Router.getParams().id}/edit`)}
                showShadow={false}
              />
            ) : false
        ), (menuItems.length !== 0 ? (
          <Components.Mobile.NavigationBarMenu
            items={menuItems}
          >
            {
              !this.props.data.archived && this._isEditable() ? (
                <Components.Archive
                  archive={async () => {
                    Utils.FullScreenLoading.FullScreenLoadingManager.open(
                      this.props.strings.Task.page.archivingItem,
                    );
                    await this.props.dispatch(ReduxActions.task.archive(this.props.data.id));
                    Utils.FullScreenLoading.FullScreenLoadingManager.close();
                  }}
                  archivePath={() => Utils.Router.transitionTo('/archives/tasks')}
                  className="vf-task__mobile-view-form__archive-button"
                  delete={async () => {
                    await this.props.dispatch(ReduxActions.task.delete(this.props.data.id));
                  }}
                  ids={[this.props.data.id]}
                  modelName={this.props.strings.Task.constants.task}
                  updateContent={() => {
                    this.props.dispatch(ReduxActions.task.fetchList());
                    Utils.Router.transitionTo('/tasks');
                  }}
                >
                  <Components.Button
                    iconClassName="versa-archive vf-task__mobile-view-form__archive-button__icon"
                  >
                    {this.props.strings.Task.form.buttons.archive}
                  </Components.Button>
                </Components.Archive>
              ) : false
            }
          </Components.Mobile.NavigationBarMenu>
        ) : false
        )]}
        title={`Task ${data.job_type === 'pickup' ? 'pickup' : 'delivery'} info`}
      />
    );
  }

  render() {
    if (Helper.isNullOrUndefined(this.props.data)) {
      return false;
    }

    return (
      <Components.Form.MobileCoreLayout
        className="vf-task__mobile-view-form"
        header={this._renderNavBar()}
      >
        <Detail
          customFieldGroups={this.props.customFieldGroups}
          data={this.props.data}
          id="vf-mobile-task__view-form"
        />
      </Components.Form.MobileCoreLayout>
    );
  }
}

MobileTaskViewForm.propTypes = {
  customFieldGroups: PropTypes.shape({}).isRequired,
  data: PropTypes.shape({
    archived: PropTypes.bool,
    epod_url: PropTypes.string,
    job: PropTypes.shape(),
    id: PropTypes.number,
    billing_account: PropTypes.shape(),
    state: PropTypes.string,
  }).isRequired,
  dispatch: PropTypes.func.isRequired,
  myjobsSetting: PropTypes.shape({
    can_edit_after_submission: PropTypes.bool,
    can_edit_after_completion: PropTypes.bool,
  }).isRequired,
  strings: PropTypes.shape({
    Task: PropTypes.shape({
      constants: PropTypes.shape({
        task: PropTypes.string,
      }),
      form: PropTypes.shape({
        buttons: PropTypes.shape({
          unarchive: PropTypes.string,
          viewEPOD: PropTypes.string,
          cancel: PropTypes.string,
          delete: PropTypes.string,
          archive: PropTypes.string,
        }),
      }),
      page: PropTypes.shape({
        loadingItem: PropTypes.string,
        unarchivingItem: PropTypes.string,
        archivingItem: PropTypes.string,
      }),
    }),
  }).isRequired,
};

const mapStateToProps = (state) => {
  const { customFieldGroup, task, profile } = state;
  return {
    customFieldGroups: customFieldGroup.customFieldGroups,
    data: task.tasks[Utils.Router.getParams().id],
    myjobsSetting: (profile.profile || {}).myjobs_setting,
  };
};

export default connect(mapStateToProps)(translate('')(MobileTaskViewForm));
